import React from 'react';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import "../../styles/not-permition-modal.css";
import { accessRestrictedSupportEmailAddress } from '../../constants';

function NotPermitionModal({ notPermitionModalHeading, open, onClose, notPermitionModalIcon }) {

    return (
        <Modal open={open} onClose={onClose}>
            <div className="not-permission-modal-container">

                <div className="not-permission-modal-header-cross-icon">
                    <button className="not-permission-modal-close-icon" onClick={onClose}>
                        <CloseIcon />
                    </button>
                </div>
                <div className="not-permission-modal-container-body">


                    <div className="not-permission-modal-header">
                        <h2 className="not-permission-modal-title">Access Restricted</h2>

                    </div>
                    <div className="not-permission-modal-body">
                        <div className="not-permission-modal-icon-wrapper">
                            <img
                                src={notPermitionModalIcon}
                                alt="Restricted"
                                className="not-permission-modal-center-icon"
                            />
                        </div>
                        <p>You don't have permission to access the <strong>{notPermitionModalHeading}Nav</strong>.</p>
                        {/* <p>
                            For getting the permission, please contact support at <br />
                            <a href= {accessRestrictedSupportEmailAddress.href} className="not-permission-modal-support-email">
                               {accessRestrictedSupportEmailAddress.email}
                            </a>
                        </p> */}

                        <p> For getting the permission, please contact product team </p>
                    </div>

                    <div className="not-permission-modal-footer">
                        <button className="not-permission-modal-close-btn" onClick={onClose}>Close</button>
                    </div>
                </div>
            </div>
        </Modal>
    );
}

export default NotPermitionModal;
